export default {
  SET_TOAST(state, payload){
    state.message = payload.message
    state.type = payload.type
    state.visible = true
  },
  SET_TOAST_VISIBLE_STATE(state, visibleState){
    state.visible = visibleState
  }
};